// extracted by mini-css-extract-plugin
export var Layout = "layout-module--Layout--7209a";
export var Layout__main = "layout-module--Layout__main--83b64";
export var LayoutNoScroll = "layout-module--Layout--no-scroll--9c2ac";